import React, { useId } from "react";

/**
 * The MySuhbat mark (2026-10-22): the staff panel's drawing, in the cabinet's
 * teal -- a speech bubble on a tile. The same drawing is public/favicon.svg.
 * `size` in px.
 */
const MySuhbatMark = ({ size = 34 }) => {
  const id = useId().replace(/:/g, "");
  return (
    <svg
      className="ms-mark"
      width={size}
      height={size}
      viewBox="0 0 64 64"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id={`g${id}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#14a08f" />
          <stop offset="1" stopColor="#0b5d57" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="16" fill={`url(#g${id})`} />
      <path
        d="M16 22c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v12c0 4.4-3.6 8-8 8H30l-8.5 7.2c-.9.8-2.3.1-2.3-1.1V42.6C17.3 41.4 16 39 16 36.3V22z"
        fill="#fff"
      />
      <rect x="24" y="24" width="16" height="3.4" rx="1.7" fill="#14a08f" />
      <rect x="24" y="31" width="10" height="3.4" rx="1.7" fill="#9fdcd3" />
    </svg>
  );
};

export default MySuhbatMark;
